import { render, staticRenderFns } from "./pcLayout.vue?vue&type=template&id=45038d94&scoped=true"
import script from "./pcLayout.vue?vue&type=script&lang=js"
export * from "./pcLayout.vue?vue&type=script&lang=js"
import style0 from "./pcLayout.vue?vue&type=style&index=0&id=45038d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45038d94",
  null
  
)

export default component.exports